(function () {
  var BASE = "/apps/ai";
  var LIMIT = 24;
  var MAX_RENDERED_TILES = 144;
  var SELECTOR = "[data-saisho-gallery-app]";

  function encode(value) {
    return encodeURIComponent(value || "");
  }

  function parseJson(node) {
    try {
      return JSON.parse(node && node.textContent ? node.textContent : "[]");
    } catch (_error) {
      return [];
    }
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function setText(node, text) {
    node.textContent = text || "";
  }

  function apiUrl(state) {
    var params = new URLSearchParams();
    params.set("limit", String(LIMIT));
    if (state.cursor) params.set("cursor", state.cursor);
    if (state.style) params.set("style", state.style);
    return BASE + "/gallery?" + params.toString();
  }

  async function fetchItems(state) {
    var response = await fetch(apiUrl(state), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("gallery failed: " + response.status);
    return response.json();
  }

  function studioHref(root, item, autogen) {
    var url = root.dataset.studioUrl || "/";
    var joiner = url.indexOf("?") === -1 ? "?" : "&";
    var params = [];
    if (item.variant_id) params.push("variant=" + encode(String(item.variant_id)));
    if (item.style) params.push("style=" + encode(item.style));
    if (item.prompt) params.push("prompt=" + encode(item.prompt));
    if (item.id && !item.is_static) params.push("gallery_item_id=" + encode(String(item.id)));
    if (item.is_static && item.image_url) params.push("reference_url=" + encode(item.image_url));
    return url + (params.length ? joiner + params.join("&") : "") + (autogen ? "#autogen=1" : "");
  }

  function quickBuyPayload(root, item) {
    var payload = {
      variant_id: item.variant_id || null,
      size_w_mm: item.size_w_mm || null,
      size_h_mm: item.size_h_mm || null,
      size_label: item.size_label || root.dataset.defaultSizeLabel || "",
      prompt: item.prompt || "",
      label: item.title || "",
      cart_token: root.dataset.cartToken || null,
      customer_id: root.dataset.customerId || null,
    };

    if (item.id && !item.is_static) {
      payload.gallery_item_id = item.id;
    } else {
      payload.preview_url = item.image_url || "";
    }
    return payload;
  }

  function createButton(text, className) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = className;
    button.textContent = text;
    return button;
  }

  function createLink(text, href, className) {
    var link = document.createElement("a");
    link.className = className;
    link.href = href;
    link.textContent = text;
    return link;
  }

  function renderTile(root, item) {
    var article = document.createElement("article");
    article.className = "sg-gallery-tile";
    article.setAttribute("data-saisho-quick-buy-tile", "");

    var image = document.createElement("img");
    image.src = item.image_url || "";
    image.alt = (item.title || "Gallery artwork") + " mat concept";
    image.width = 1200;
    image.height = 600;
    image.loading = "lazy";
    article.appendChild(image);

    var label = document.createElement("div");
    label.className = "sg-gallery-tile__label";
    setText(label, item.title || "Untitled");
    article.appendChild(label);

    var actions = document.createElement("div");
    actions.className = "sg-gallery-tile__actions";

    var tileTitle = item.title || "this design";
    if (item.variant_id || (item.id && !item.is_static)) {
      var add = createButton("Add", "sg-btn sg-btn-primary sg-btn-sm sg-gallery-tile__btn");
      add.setAttribute("data-saisho-quick-buy", JSON.stringify(quickBuyPayload(root, item)));
      add.setAttribute("aria-label", "Add " + tileTitle + " to cart");
      actions.appendChild(add);
    }
    var customize = createLink("Edit", studioHref(root, item, false), "sg-btn sg-btn-secondary sg-btn-sm sg-gallery-tile__btn");
    customize.setAttribute("aria-label", "Edit " + tileTitle + " in the design studio");
    actions.appendChild(customize);
    article.appendChild(actions);

    return article;
  }

  function appendItems(root, items, reset) {
    var wall = root.querySelector("[data-gallery-wall]");
    if (!wall) return;
    if (reset) clear(wall);
    items.forEach(function (item) {
      wall.appendChild(renderTile(root, item));
    });
    while (wall.children.length > MAX_RENDERED_TILES) {
      wall.removeChild(wall.firstElementChild);
    }
  }

  function setActiveFilter(root, style) {
    root.querySelectorAll("[data-gallery-style]").forEach(function (button) {
      var active = (button.getAttribute("data-gallery-style") || "") === (style || "");
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function setStatus(root, message) {
    var status = root.querySelector("[data-gallery-status]");
    if (status) status.textContent = message || "";
  }

  function getFallbackItems(root, style) {
    var items = parseJson(root.querySelector("[data-gallery-fallback]"));
    return items
      .map(function (item) {
        item.is_static = true;
        return item;
      })
      .filter(function (item) {
        return !style || item.style === style;
      });
  }

  async function load(root, state, reset) {
    if (state.loading) return;
    state.loading = true;
    var loadMore = root.querySelector("[data-gallery-load-more]");
    if (loadMore) loadMore.disabled = true;
    setStatus(root, reset ? "Loading gallery..." : "Loading more...");

    if (reset) state.cursor = null;

    try {
      var result = await fetchItems(state);
      var items = Array.isArray(result.items) ? result.items : [];
      state.cursor = result.next_cursor || null;
      state.usingFallback = false;
      if (!items.length && reset) {
        items = getFallbackItems(root, state.style);
        state.cursor = null;
        state.usingFallback = true;
      }
      appendItems(root, items, reset);
      setStatus(root, items.length ? "" : "No designs in this filter yet.");
    } catch (error) {
      var fallback = reset ? getFallbackItems(root, state.style) : [];
      if (fallback.length) {
        appendItems(root, fallback, true);
        state.cursor = null;
        state.usingFallback = true;
        setStatus(root, "");
      } else {
        setStatus(root, "Gallery is temporarily unavailable.");
      }
      console.error("[saisho-gallery]", error);
    } finally {
      state.loading = false;
      if (loadMore) {
        loadMore.disabled = false;
        loadMore.hidden = !state.cursor || state.usingFallback;
      }
    }
  }

  function mount(root) {
    if (root.dataset.galleryMounted === "true") return;
    root.dataset.galleryMounted = "true";
    var state = { cursor: null, style: "", loading: false, usingFallback: false };

    root.querySelectorAll("[data-gallery-style]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.style = button.getAttribute("data-gallery-style") || "";
        setActiveFilter(root, state.style);
        load(root, state, true);
      });
    });

    var loadMore = root.querySelector("[data-gallery-load-more]");
    if (loadMore) loadMore.addEventListener("click", function () {
      load(root, state, false);
    });

    if (loadMore && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; }) && state.cursor) {
          load(root, state, false);
        }
      }, { rootMargin: "500px 0px" });
      observer.observe(loadMore);
    }

    setActiveFilter(root, "");
    load(root, state, true);
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(mount);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
